import { createContext, useContext, useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";

import { UserDataContext } from "./userDataContext";

export const DataTableContext = createContext({});

export const DataTableProvider = ({
	children,
	initialIsErrorState = false,
	apiFunction,
	dataTableColumnSettings,
	dataTableEditorSettings,
	triggerRefresh = null,
	isLoading = false,
	queryKey = "queryKey",
	refreshKey = queryKey,
	isEnabled = true,
}: {
	children: any;
	initialIsErrorState?: boolean | null;
	apiFunction: () => Promise<{
		tableData: Array<any>;
		fetched: number;
		totalAvailable: number;
	}>;
	dataTableColumnSettings: any;
	dataTableEditorSettings?: any;
	triggerRefresh?: boolean | null;
	isLoading?: boolean | null;
	queryKey?: string | string[];
	refreshKey?: string | string[];
	isEnabled?: boolean;
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalAction, setOrgModalAction] = useState("");
	const [initialModalData, setInitialModalData] = useState([{}]);
	const [isSelect, setIsSelect] = useState(false);

	const queryKeys = Array.isArray(queryKey) ? queryKey : [queryKey];
	const refreshKeys = Array.isArray(refreshKey) ? refreshKey : [refreshKey];

	const { selectedOrgId } = useContext(UserDataContext);
	const {
		isLoading: isTableLoading,
		isFetching,
		error,
		data,
	} = useQuery([...queryKeys, "selectedOrgId", selectedOrgId], apiFunction, {
		enabled: isEnabled,
	});

	const queryData = data || {
		tableData: [],
		fetched: 0,
		totalAvailable: 0,
	};

	const tableData = queryData.tableData;

	let dataError = null;
	if (!Array.isArray(tableData)) {
		dataError = "Bad data";
		console.error(dataError);
	}

	const fetched = queryData?.fetched || tableData.length;
	const totalAvailable = queryData?.totalAvailable || tableData.length;

	const queryClient = useQueryClient();

	const refreshTableData = () =>
		queryClient.invalidateQueries({ queryKey: [...refreshKeys] });

	useEffect(() => {
		if (triggerRefresh !== null) refreshTableData();
	}, [triggerRefresh]);

	return (
		<DataTableContext.Provider
			value={{
				isModalOpen,
				setIsModalOpen,
				modalAction,
				setOrgModalAction,
				initialModalData,
				setInitialModalData,
				isLoading: isTableLoading || isLoading,
				isFetching,
				tableData,
				isError: initialIsErrorState || error || dataError,
				dataTableColumnSettings,
				dataTableEditorSettings,
				paginationData: { fetched, totalAvailable },
				refreshTableData,
				isSelect,
				setIsSelect,
			}}
		>
			{children}
		</DataTableContext.Provider>
	);
};
